<template>
  <mobile-recommend />
  <router-view />
</template>
<script setup>
import { reactive } from 'vue'
import MobileRecommend from '@/components/MobileRecommend'

const keyPressed = reactive({
  KeyS: false,
  Digit0: false
})

document.onkeyup = () => {
  for (const key in keyPressed) {
    keyPressed[key] = false
  }
}

document.onkeydown = e => {
  if (Object.keys(keyPressed).includes(e.code)) {
    keyPressed[e.code] = true
    if (!Object.values(keyPressed).includes(false)) {
      localStorage.removeItem('swrv')
      location.reload()
    }
  }
}
</script>
<style lang="scss">
.swiper-container {
  overflow: unset !important;
}
.toast-enter-active {
  animation: toast-in 0.5s;
}
.toast-leave-active {
  animation: toast-in 0.5s reverse;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
